import React from "react"
import { graphql } from "gatsby"

import { SEO } from "components"

import Hero from "./_Hero"
import Details from "./_Details"
import Varieties from "./_Varieties"
import Accordion from "./_Accordion"

function ProductSubCategory({ data }) {
  const { contentfulProductCategory, contentfulProductSubcategory } = data
  const category = contentfulProductCategory
  const subcategory = contentfulProductSubcategory

  return (
    <>
      <SEO
        title={subcategory?.title + " | " + category?.name}
        description={subcategory?.seoDescription?.internal?.content}
        image={subcategory?.photo}
      />
      <main>
        <Hero category={category} subcategory={subcategory} />
        <Varieties
          category={category}
          subcategory={subcategory}
          products={subcategory?.products}
        />
        <Details category={category} subcategory={subcategory} />
        <Accordion category={category} />
      </main>
    </>
  )
}

export const pageQuery = graphql`
  query ProductSubCategoryQuery($slug: String, $category: String) {
    contentfulProductSubcategory(slug: { eq: $slug }) {
      slug
      title
      seoDescription {
        internal {
          content
        }
      }
      slogan
      description {
        raw
      }
      photo {
        ...AssetFragment
        gatsbyImageData(width: 388, placeholder: BLURRED, quality: 75)
      }
      decorators {
        ...DecoratorFragment
      }
      products {
        name
        description {
          raw
        }
        image {
          ...AssetFragment
          small: gatsbyImageData(
            width: 284
            aspectRatio: 1
            resizingBehavior: FILL
            placeholder: BLURRED
            quality: 75
          )
          large: gatsbyImageData(width: 698, placeholder: BLURRED, quality: 75)
        }
      }
      certificationsText {
        raw
      }
      certifications {
        name
        icon {
          ...AssetFragment
          gatsbyImageData(
            width: 96
            aspectRatio: 1
            resizingBehavior: PAD
            quality: 75
          )
        }
      }
      options {
        options
      }
      size {
        size
      }
      videoCaption {
        raw
      }
      scale {
        raw
      }
    }
    contentfulProductCategory(slug: { eq: $category }) {
      slug
      name
      slogan
      fillerText
      description {
        description
      }
      colorTheme
      image {
        ...AssetFragment
        small: gatsbyImageData(
          width: 284
          aspectRatio: 1
          resizingBehavior: FILL
          placeholder: BLURRED
          quality: 75
        )
        large: gatsbyImageData(width: 698, placeholder: BLURRED, quality: 75)
      }
      video {
        ...AssetFragment
      }
      videoPreview {
        ...AssetFragment
        gatsbyImageData(width: 768)
      }
      faqTitle
      faqItems {
        title
        content {
          raw
        }
      }
    }
  }
`

export default ProductSubCategory
